module.exports = __webpack_public_path__ + "img/smartphone-home.d7f45937.png";